const AdobeAnalyticsPageType = {
  MOBILE_LOGIN: "account login",
};

export default AdobeAnalyticsPageType;
